import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { AuthClientHelper } from './core/helpers/auth/auth-client.helper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SpinnerHelper } from './core/helpers/spinner/spinner.helper';
import { ImageHelper } from './core/helpers/image/image.helper';
import { IUser } from './core/api/user/client.service';
import { ToastrService } from 'ngx-toastr';

declare function setContentHeight();

@Component({
    selector: 'app-component',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewChecked {
    public loading;
    public loadingText;
    public user: IUser;
    public isLogged;

    constructor(private auth: AuthClientHelper,
        private router: Router,
        public imageHelper: ImageHelper,
        private toastr: ToastrService) {
        this.loading = false;
    }

    ngAfterViewChecked() {
        setContentHeight();
    }

    ngOnInit() {

        this.auth.isLogged.subscribe((val) => {
            this.isLogged = val;
        });

        this.auth.user.subscribe((val) => {
            this.user = val;
        });

        SpinnerHelper.loaderStatus.subscribe((val) => {
            this.loading = val;
        });

        SpinnerHelper.loaderText.subscribe((text: string) => {
            this.loadingText = text;
        });

        if (this.user) {
            this.auth.setUserStatus(true);
        }


    }

    logout() {
        this.router.navigate(['/login']);
        this.auth.clearUser();
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts